import { Component, OnInit } from '@angular/core';
import { InceptionService, TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-norton360-details',
  templateUrl: './norton360-details.component.html',
  styleUrls: ['./norton360-details.component.css'],
})
export class Norton360DetailsComponent implements OnInit {
  backUrlFromApp: string;

  constructor(
    private inceptionService: InceptionService,
    private translationService: TranslationService,
  ) {}

  ngOnInit(): void {
    if (window['MyProximusMobileApp']) {
      this.backUrlFromApp = this.translationService.getTranslatedValueFor(
        'common.myproximus.back.url',
      );
    }
    this.scrollToTop();
  }

  private scrollToTop(): void {
    setTimeout(() => {
      this.inceptionService.scrollToElement('#norton360Details');
    });
  }

  goBack() {
    this.backUrlFromApp
      ? window.open(this.backUrlFromApp)
      : window.history.back();
  }
}
